import { render, staticRenderFns } from "./LocationsView.vue?vue&type=template&id=9d35927a&scoped=true"
import script from "./LocationsView.vue?vue&type=script&lang=js"
export * from "./LocationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d35927a",
  null
  
)

export default component.exports